import React from "react";
import { useSelector } from "react-redux";
import { PieChart } from "@mui/x-charts/PieChart";
import "./DataAccessibility.scss";

export const formatNumber = (num) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
  return num;
};

export const formatRange = (range) => {
  if (range.includes("60-90")) return "3 Months";
  if (range.includes("90-180")) return "6 Months";
  if (range.includes(">365")) return ">1 Year";
  return range;
};

function DataAccessibility() {
  const total = useSelector((state) => state.dataTagReducer.totalFiles);
  const publicCount = useSelector(
    (state) =>
      state.dataTagReducer.dataAccessibility?.publiclyAccessibleFileCount
  );
  const unAccessedBuckets = useSelector(
    (state) => state.dataTagReducer.dataAccessibility?.unAccessedBuckets
  );

  const chartData = [
    { id: 0, value: publicCount, color: "#FFAE73" },
    { id: 1, value: total - publicCount, color: "#3A5BFF" },
  ];

  const requiredRanges = ["60-90 days", "90-180 days", ">365 days"];
  const filteredBuckets = unAccessedBuckets?.filter((b) =>
    requiredRanges.includes(b.accessRange)
  );

  const maxBucket = filteredBuckets?.length
    ? Math.max(...filteredBuckets.map((b) => b.fileCount))
    : 0;

  return (
    <div className="da-container">
      <div className="da-title">Data Accessibility Index</div>

      <div className="da-chart-section">
        <div className="da-chart-fixed">
          <PieChart
            series={[
              {
                innerRadius: 32,
                outerRadius: 38,
                paddingAngle: 3,
                cornerRadius: 5,
                data: chartData,
              },
            ]}
            margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
            width={80}
            height={80}
          />
        </div>

        <div className="da-legend">
          <div className="legend-item">
            <span className="dot" style={{ background: "#FFAE73" }}></span>
            <span className="legend-text">Public</span>
            <span className="legend-count">{publicCount}</span>
          </div>

          <div className="legend-item">
            <span className="dot" style={{ background: "#3A5BFF" }}></span>
            <span className="legend-text">Non Public</span>
            <span className="legend-count">{total}</span>
          </div>
        </div>
      </div>

      <div className="da-gradient-bars">
        {filteredBuckets?.map((item, idx) => {
          const percentage =
            maxBucket > 0 ? (item.fileCount / maxBucket) * 100 : 0;

          return (
            <div key={idx} className="bar-wrapper">
              <p className="bar-label">
                Files not accessed in {formatRange(item.accessRange)}
              </p>

              <div
                className="gradient-bar"
                style={{ width: `${percentage}%` }}
                title={`Files not accessed ${item.fileCount.toLocaleString()}`}
              >
                <div className="bar-value">{formatNumber(item.fileCount)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DataAccessibility;
